import { Location } from '@angular/common';
import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CustomPattern } from 'src/app-core/pattern/custom-pattern';
import { CommonService } from 'src/app-core/services/common.service';
import { ContactDataModel } from 'src/app/contacts/contact-data-model';
import { ContactService } from 'src/app/contacts/contact.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CustomerDataModel } from 'src/app/customer/customer-data-model';
import { CustomerService } from 'src/app/customer/customer.service';

@Component({
    selector: 'app-customer-edit-form-popup',
    templateUrl: './customer-edit-form-popup.component.html',
    styleUrls: ['./customer-edit-form-popup.component.scss']
})
export class CustomerEditFormPopupComponent implements OnInit {

    @ViewChild('customerForm', { static: true }) customerForm: NgForm;
    customerDataModel = new CustomerDataModel();
    contactDataModel = new ContactDataModel();
    pattern = new CustomPattern();
    customerEditFormList: any = Object.assign({}, this.customerDataModel.customerEditFormModel);
    leadSources: any = [];
    employees: any = [];
    industries: any = [];
    contacts: any = [];
    addresses: any = [];
    contactDetails: any = Object.assign({}, this.contactDataModel.contactDetails);
    addressDetails: any;
    createType = 'Create & Quote';
    customerId: string;
    leadAcc: boolean;
    accountLongId: string;
    isFormLoading = true;
    isUpdating = false;
    accountDetails = this.customerDataModel.accountDetails;
    modelData: any;

    constructor(
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<CustomerEditFormPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: MatDialog,
        private location: Location,
        private toastr: ToastrService,
        private router: Router,
        private commonService: CommonService,
        private contactService: ContactService,
        private activatedRoute: ActivatedRoute,
        private customerService: CustomerService
    ) {
        this.modelData = this.data;
    }

    ngOnInit() {
        this.customerId = this.modelData.accountId;
        this.loadItems();
    }
    loadItems(): void {
        this.getIndustries();
        this.getContacts();
        this.editCustomer();
    }

    onUpdateCustomer(): void {
        this.isUpdating = true;
        this.isFormLoading = true;
        this.customerEditFormList.isIndividualAccount = this.customerEditFormList.isIndividualAccount === '1' ? false : true;
        this.customerEditFormList.isConvertedCustomer = this.leadAcc;
        this.customerService.updateAccount(this.customerEditFormList)
            .pipe(finalize(() => (this.isUpdating = false)))
            .subscribe(res => {
                this.isFormLoading = false;
                this.toastr.success('Customer account updated successfully.');
                const sendingData = {
                    success: true,
                    data: this.customerEditFormList
                };
                this.dialogRef.close(sendingData);
            });
    }

    editCustomer(): void {
        this.customerService.editAccount(this.customerId)
            .pipe(finalize(() => (this.isFormLoading = false)))
            .subscribe(response => {
                if (response.isSuccess) {
                    this.customerEditFormList = response.data;
                    this.accountLongId = this.customerEditFormList.id;
                    this.getAddresses();
                    this.accountDetails = Object.assign(
                        {},
                        { accountName: this.customerEditFormList.accountName, isIndividualAccount: this.customerEditFormList.isIndividualAccount },
                    );
                    this.customerEditFormList.accountDetails.accountStatusId = this.customerEditFormList.accountDetails.accountStatusId.toString();
                    this.customerEditFormList.isIndividualAccount = this.customerEditFormList.isIndividualAccount === false ? '1' : '2';
                    if (this.customerEditFormList.contact.contactId) {
                        this.getContact(this.customerEditFormList.contact.contactId);
                    }
                    this.getLeadSources();
                    this.getEmployees();
                }
            });
    }

    getLeadSources(): void {
        const query = this.customerEditFormList.isRfqAccount ? '' : `IsRfQ=false`;
        this.commonService.getLeadSources(query).subscribe(response => {
            this.leadSources = response.data;
        });
    }

    getEmployees(): void {
        this.commonService.getEmployees(this.customerEditFormList.accountDetails.assignedTo || 0).subscribe(response => {
            if (response.isSuccess) {
                this.employees = response.data;
            }
        });
    }

    getIndustries(): void {
        this.commonService.getIndustries().subscribe(response => {
            this.industries = response.data;
        });
    }

    getContacts(): void {
        const searchQuery = `AccountId=${this.customerId}&searchQuery=`;
        this.contactService.getContacts(searchQuery).subscribe(response => {
            this.contacts = response.data;
        });
    }

    getContact(contactId: string): void {
        this.customerEditFormList.contact.contactId = contactId;
        this.contactService.getRecord(contactId).subscribe(response => {
            this.contactDetails = response.data;
            if (this.contactDetails.primaryPhone && !this.contactDetails.isInternationalPhone) {
                this.contactDetails.primaryPhone = this.commonService.getFormattedPhoneNumber(this.contactDetails.primaryPhone);
            }
        });
    }

    getAddresses(): void {
        const searchQuery = `AccountId=${this.accountLongId}&searchQuery=`;
        this.contactService.getAddresses(searchQuery).subscribe((response: any) => {
            this.addresses = response.data;
        });
    }

    onAccountTypeChange() {
        this.customerEditFormList.accountName = this.accountDetails.isIndividualAccount === false ? this.accountDetails.accountName : '';
    }

    onChangeContact(contact: any) {
        if (contact) {
            this.getContact(contact.contactId);
        }
    }

    onGotoDetail(): void {
        // this.location.back();
        this.onClose();
    }

    onGotoCustomerList(): void {
        this.router.navigateByUrl(`app/customer/customer-list/all-accounts`);
    }

    // start onSave
    onSave() {
        const sendingData = {};
        this.dialogRef.close(sendingData);
    }
    // end onSave

    // start onClose
    onClose(): void {
        this.dialogRef.close(false);
    }
    // end onClose

}
